(function($) {
  'use strict';

  $('.footer_accordion').find('.accordion-toggle').on('click', function() {
    // Expand or collapse this panel
    $(this).parent().toggleClass('showing');
  });

  //ZDS UPDATE

  $('.footer_accordion').find('.group_header').on('click', function() {
    // Expand or collapse this panel
    $(this).parent().toggleClass('open');
  });


}(window.jQuery || window.Zepto || window.$));
